'use client';

import { c as _c } from "react/compiler-runtime";
import { Badge } from '@common/components';
import { INTERACTIVE_SURFACE } from '@common/components/interaction';
import { useClipboard } from '@common/hooks';
import SvgAlignBack from '@common/icon/SvgAlignBack';
import SvgChevronright from '@common/icon/SvgChevronright';
import { cn } from '@core/utils';
import { useState } from 'react';
import { CHANNEL_LABEL, formatWon } from '../../_utils/labels';
import { createdLabelOf, linkCopyTextOf, shortLinkOf, targetTextOf } from '../../_utils/links';
import type { PartnersLinkStats } from '../../_utils/types';
import { LinkDoneDialog } from '../home/LinkDoneDialog';
import { ChannelMark } from './ChannelMark';
interface LinkCardProps {
  link: PartnersLinkStats;
  rangeLabel?: string;
}
export const LinkCard = t0 => {
  const $ = _c(61);
  const {
    link,
    rangeLabel: t1
  } = t0;
  const rangeLabel = t1 === undefined ? "\uAE30\uAC04" : t1;
  const copyToClipboard = useClipboard();
  const [isDoneOpened, setIsDoneOpened] = useState(false);
  let t2;
  if ($[0] !== copyToClipboard || $[1] !== link.code) {
    t2 = () => {
      copyToClipboard({
        value: linkCopyTextOf(link.code),
        message: "\uB9C1\uD06C\uBCF5\uC0AC \uC644\uB8CC!"
      });
    };
    $[0] = copyToClipboard;
    $[1] = link.code;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleCopy = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = cn(INTERACTIVE_SURFACE, "relative flex flex-col gap-12 rounded-small border border-Gray-200 bg-Gray-white p-16");
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== link.channel) {
    t4 = link.channel === null || link.channel === "ETC" || link.channel === "PERSONAL_BLOG" ? <Badge dimensions="H20" className="shrink-0">{CHANNEL_LABEL[link.channel ?? "ETC"]}</Badge> : <ChannelMark channel={link.channel} />;
    $[4] = link.channel;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setIsDoneOpened(true);
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== link.contentName) {
    t6 = <span className="min-w-0 flex-1 truncate">{link.contentName}</span>;
    $[7] = link.contentName;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <span className="flex size-24 shrink-0 items-center justify-center"><SvgChevronright aria-hidden={true} className="size-16 text-Gray-600 transition-transform group-hover:translate-x-1 group-focus-visible:translate-x-1" /></span>;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t6) {
    t8 = <h3 className="min-w-0 flex-1 font-700 text-Gray-900 typo-body3"><button className="group flex w-full items-center gap-8 text-left after:absolute after:inset-0 after:rounded-small focus-visible:outline-none focus-visible:after:outline focus-visible:after:outline-2 focus-visible:after:-outline-offset-2 focus-visible:after:outline-B-500" onClick={t5}>{t6}{t7}</button></h3>;
    $[10] = t6;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t4 || $[13] !== t8) {
    t9 = <div className="flex items-center gap-8">{t4}{t8}</div>;
    $[12] = t4;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== link) {
    t10 = targetTextOf(link);
    $[15] = link;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10) {
    t11 = <span className="min-w-0 truncate">{t10}</span>;
    $[17] = t10;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== link) {
    t12 = createdLabelOf(link);
    $[19] = link;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t12) {
    t13 = <span className="shrink-0">{t12}</span>;
    $[21] = t12;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t11 || $[24] !== t13) {
    t14 = <div className="flex w-full justify-between gap-8 text-Gray-700 typo-caption1">{t11}{t13}</div>;
    $[23] = t11;
    $[24] = t13;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== link.code) {
    t15 = shortLinkOf(link.code);
    $[26] = link.code;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  const t16 = `${t15} 링크 복사`;
  let t17;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = cn(INTERACTIVE_SURFACE, "relative -mx-4 flex items-center gap-4 rounded-xxsmall px-4 text-Gray-800 underline typo-caption1");
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  let t18;
  if ($[29] !== link.code) {
    t18 = shortLinkOf(link.code);
    $[29] = link.code;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  let t19;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <SvgAlignBack aria-hidden={true} className="size-11 text-Gray-800" />;
    $[31] = t19;
  } else {
    t19 = $[31];
  }
  let t20;
  if ($[32] !== handleCopy || $[33] !== t16 || $[34] !== t18) {
    t20 = <button aria-label={t16} className={t17} onClick={handleCopy}>{t18}{t19}</button>;
    $[32] = handleCopy;
    $[33] = t16;
    $[34] = t18;
    $[35] = t20;
  } else {
    t20 = $[35];
  }
  let t21;
  if ($[36] !== t14 || $[37] !== t20) {
    t21 = <div className="flex flex-col items-start gap-4">{t14}{t20}</div>;
    $[36] = t14;
    $[37] = t20;
    $[38] = t21;
  } else {
    t21 = $[38];
  }
  let t22;
  if ($[39] !== rangeLabel) {
    t22 = <span className="min-w-0 break-keep text-Gray-700 typo-caption1">{rangeLabel} 실적</span>;
    $[39] = rangeLabel;
    $[40] = t22;
  } else {
    t22 = $[40];
  }
  let t23;
  if ($[41] !== link.donorCount) {
    t23 = link.donorCount.toLocaleString("ko-KR");
    $[41] = link.donorCount;
    $[42] = t23;
  } else {
    t23 = $[42];
  }
  let t24;
  if ($[43] !== link.rewardAmount) {
    t24 = formatWon(link.rewardAmount);
    $[43] = link.rewardAmount;
    $[44] = t24;
  } else {
    t24 = $[44];
  }
  let t25;
  if ($[45] !== t24) {
    t25 = <span className="text-B-550">{t24}</span>;
    $[45] = t24;
    $[46] = t25;
  } else {
    t25 = $[46];
  }
  let t26;
  if ($[47] !== t23 || $[48] !== t25) {
    t26 = <span className="shrink-0 whitespace-nowrap text-Gray-900 typo-body4">{t23}명 ·{" "}{t25}</span>;
    $[47] = t23;
    $[48] = t25;
    $[49] = t26;
  } else {
    t26 = $[49];
  }
  let t27;
  if ($[50] !== t22 || $[51] !== t26) {
    t27 = <p className="flex items-center justify-between gap-8 rounded-xsmall bg-Gray-25 px-12 py-8">{t22}{t26}</p>;
    $[50] = t22;
    $[51] = t26;
    $[52] = t27;
  } else {
    t27 = $[52];
  }
  const t28 = isDoneOpened ? link : null;
  let t29;
  if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = () => setIsDoneOpened(false);
    $[53] = t29;
  } else {
    t29 = $[53];
  }
  let t30;
  if ($[54] !== t28) {
    t30 = <LinkDoneDialog link={t28} onClose={t29} />;
    $[54] = t28;
    $[55] = t30;
  } else {
    t30 = $[55];
  }
  let t31;
  if ($[56] !== t21 || $[57] !== t27 || $[58] !== t30 || $[59] !== t9) {
    t31 = <article className={t3}>{t9}{t21}{t27}{t30}</article>;
    $[56] = t21;
    $[57] = t27;
    $[58] = t30;
    $[59] = t9;
    $[60] = t31;
  } else {
    t31 = $[60];
  }
  return t31;
};